import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import StudentAttendanceContent from "../../containers/logged_user_components/user_exercise_test/user_adaptive_cps/components/user_attendance/StudentAttendanceContent";
import StudentDayMonthAttendanceContent from "./StudentDayMonthAttendanceContent";
import ParentHeader from "../parentHeader/ParentHeader";
import axios from "axios";
import uiActions from "../../redux/ui/action";
import LoaderPopUp from "../../components/loader/loader";

const UserAttendanceContent = (props) => {
  const { loginFromParent, rollNo, startLoading, finishLoading, loader } = props;

  const [isAnushaasan, setIsAnushaasan] = useState(null);

  useEffect(() => {
    const roll = rollNo;
    

    const getStudentProfile = async () => {
      startLoading();
      try {
        const response = await axios.post(
          "https://learning.motion.ac.in/motioneducation/api/Parentdashboard",
          { roll_no: roll }
        );

        console.log("API Response:", response.data);

        if (response.data.status === 200) {
          const isAnushaasanValue = response.data.is_anushaasan;
          if (isAnushaasanValue) {
            // For day/month attendance flow, stop global loader here.
            finishLoading();
          }

          console.log("received is_anushaasan:", isAnushaasanValue);
          setIsAnushaasan(isAnushaasanValue);
        }
      } catch (error) {
        console.error("Error fetching student profile:", error);
        setIsAnushaasan(false);
        finishLoading();
      }
    };

    getStudentProfile();
  }, [rollNo]);

  return (
    <div className="user-attendance-wrapper">
      {loginFromParent && <ParentHeader />}

      {isAnushaasan === null ? null : (
        <div>
          <div className="attendance-content-container">
            {!isAnushaasan ? (
              <StudentAttendanceContent finishLoading={finishLoading} startLoading={startLoading} />
            ) : (
              <StudentDayMonthAttendanceContent />
            )}
          </div>
        </div>
      )}
      {loader && <LoaderPopUp />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loader: state.ui.loader,
  rollNo: state.parentrootReducer.parentAuthReducer.user.st_rollno,
  loginFromParent: state.parentrootReducer.parentAuthReducer.loginFromParent,
  
});

const mapDispatchToProps = (dispatch) => ({
  startLoading: () => dispatch(uiActions.startLoading()),
  finishLoading: () => dispatch(uiActions.finishLoading()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAttendanceContent);
